import { gql } from "@apollo/client";

export const ADMIN_MAINTENANCE_REVENUE = gql`
  query AdminMaintenanceRevenue($period: AnalyticsLastNMonthsRange) {
    adminMaintenanceRevenue(period: $period) {
      total
      monthlyTotals {
        monthKey
        monthLabel
        total
      }
    }
  }
`;

export const ADMIN_TALENT_UNLOCK_REVENUE = gql`
  query AdminTalentUnlockRevenue($period: AnalyticsLastNMonthsRange) {
    adminTalentUnlockRevenue(period: $period) {
      total
      monthlyTotals {
        monthKey
        monthLabel
        total
      }
    }
  }
`;
